<template>
  <div>
    <el-form label-position="left" class="main-form-scroll">
      <div v-for="(param, index) in paramLines" :key="index" class="el-form-line" :ref="'param'+index">
        <div style="display: flex">
          <el-form-item>
            <el-select v-model="param.idCmdParam" filterable :placeholder="$t('navigation.configTaskForm.param')">
              <el-option v-for="p in getParamsTable" :key="p.id" :label="p.name" :value="p.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('navigation.configTaskForm.name')" style="display: flex; margin-left: 20px;">
            <el-input v-model="param.Caption"></el-input>
          </el-form-item>
        </div>
        <el-form-item :label="$t('navigation.configTaskForm.lenght')">
          <el-input v-model="param.MaxLength" type="number" style="width: 120px"></el-input>
        </el-form-item>
        <el-form-item label="Prompt" v-if="param.idCmdParam ==='7'">
          <el-input v-model="param.Prompt"></el-input>
        </el-form-item>
        <div class="buttons">
          <el-button @click="addParam(param)" icon="el-icon-plus" size="mini"></el-button>
          <el-button @click.prevent="removeParam(param)" icon="el-icon-delete" size="mini"></el-button>
          <el-button @click.prevent="moveUp(param)" icon="el-icon-top" size="mini"></el-button>
          <el-button @click.prevent="moveDown(param)" icon="el-icon-bottom" size="mini"></el-button>
          <!-- <span class="nn-index">[{{index}}]</span> -->
        </div>
      </div>
    </el-form>
    <div slot="footer" class="bottom-buttons">
      <div></div>
      <div>
        <el-button class="button-cancel" type="plain" @click="cancelClick">{{ $t('navigation.configTaskForm.cancel') }}</el-button>
        <el-button class="button-confirm" type="success" @click="okClick">OK</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      paramLines: []
    };
  },
  methods: {
    addParam(param) {
      // //console.log(this.paramLines);
      let index = this.paramLines.indexOf(param);
      // //console.log(param);
      this.paramLines.splice(index + 1, 0, {
        idCmdParam: null,
        Caption: "",
        MaxLength: null,
        Prompt: null
      });
       const ref = `param${index + 1}`;
      this.$nextTick()
        .then(() => {
          const newElement = this.$refs[ref];
          newElement[0].scrollIntoView();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    removeParam(param) {
      let index = this.paramLines.indexOf(param);
      if (index >= 0) {
        let removed = this.paramLines.splice(index, 1);
      }
    },
    moveUp(param) {
      let index = this.paramLines.indexOf(param);
      if (index > 0) {
        this.paramLines.splice(index - 1, 0, param);
        this.paramLines.splice(index + 1, 1);
      }
    },
    moveDown(param) {
      let index = this.paramLines.indexOf(param);
      if (index < this.paramLines.length) {
        this.paramLines.splice(index + 2, 0, param);
        this.paramLines.splice(index, 1);
      }
    },
    cancelClick() {
      this.paramLines = [];
      this.$emit("onClose");
    },
    okClick() {
      //console.log("FINAL", this.paramLines);
      for (let param of this.paramLines) {
        // console.log("param: ", param);
        if(!param.Caption || !param.idCmdParam){
          this.$alert("not all params are filled");
          return;
        }
        for (let index in param) {
          // console.log("index", index);
          if (param[index] === null) {
            param[index] = "null";
          }
        }
      }
      this.$emit("addOk", this.paramLines);
    }
  },
  created() {
    //console.log(this.getRTCmdLine);
    if (this.getRTCmdLine.length > 0) {
      for (let ob of this.getRTCmdLine) {
        //console.log(ob);
        this.paramLines.push({
          idCmdParam: this.getParamsTable.find(
            param => param.name === ob.ftParam
          ).id,
          Caption: ob.caption,
          MaxLength: ob.maxLength,
          Prompt: ob.prompt
        });
      }
    } else {
      this.addParam();
    }
  },
  computed: {
    ...mapGetters(["getRTCmdLine", "getParamsTable"])
  }
};
</script>

<style scoped>
.el-input {
  width: 400px;
}
.el-form-line {
  border: 1px dotted var(--main-background);
  padding: 5px 2px;
  border-radius: 5px;
}
.el-form-line:last-of-type {
  margin-bottom: 15px;
}
.el-form-line:not(:first-of-type) {
  margin-top: 20px;
}
.nn-index {
  margin-left: 10px;
  margin-bottom: 2px;
}
</style>